// extracted by mini-css-extract-plugin
export default {"scoreBlock":"Ne4LGhIITP9R2_jPCogK","scoreBar":"HbhtVfjYLqaLK4xb4yHL","blank":"BIWYS2yL9sRgyOhJ8Na1","fill":"toidOtr3DCAOeWZC2d1h","labelContainer":"FHMPxgvARJvlE0NgVsof"};